import { V as VExpandTransition } from "./index-dbde2d54.mjs";
import { d as defineComponent, p as propsFactory, I as IconValue, m as makeComponentProps, b as makeTagProps, a as genericComponent, u as useRender, V as VDefaultsProvider, M as MaybeTransition, c as useTextColor, e as makeThemeProps, f as provideTheme, h as convertToUnit, i as deepEqual, j as getPropertyFromItem, o as omit, E as EventProp, k as makeDensityProps, l as makeDimensionProps, n as makeRoundedProps, q as useBackgroundColor, r as useDensity, s as useDimension, v as useRounded, w as provideDefaults, x as focusChild } from "./_density-8094aebe.mjs";
import { u as useNestedItem, a as useList, b as useNestedGroupActivator, c as createList, V as VListItem, m as makeNestedProps, d as makeBorderProps, e as makeElevationProps, f as useBorder, g as useElevation, h as useNested } from "./_VListItem-508e4b13.mjs";
import { shallowRef, onMounted, computed, readonly, toRef, ref } from "vue";
import { m as makeVariantProps } from "./MalarkeyContactAvatar-1b079ba3.mjs";
const _VList = "";
function useSsrBoot() {
  const isBooted = shallowRef(false);
  onMounted(() => {
    window.requestAnimationFrame(() => {
      isBooted.value = true;
    });
  });
  const ssrBootStyles = computed(() => !isBooted.value ? {
    transition: "none !important"
  } : void 0);
  return { ssrBootStyles, isBooted: readonly(isBooted) };
}
const VListGroupActivator = defineComponent({
  name: "VListGroupActivator",
  setup(_, { slots }) {
    useNestedGroupActivator();
    return () => {
      var _a;
      return (_a = slots.default) == null ? void 0 : _a.call(slots);
    };
  }
});
const makeVListGroupProps = propsFactory({
  /* @deprecated */
  activeColor: String,
  baseColor: String,
  color: String,
  collapseIcon: {
    type: IconValue,
    default: "$collapse"
  },
  expandIcon: {
    type: IconValue,
    default: "$expand"
  },
  prependIcon: IconValue,
  appendIcon: IconValue,
  fluid: Boolean,
  subgroup: Boolean,
  title: String,
  value: null,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VListGroup");
const VListGroup = genericComponent()({
  name: "VListGroup",
  props: makeVListGroupProps(),
  setup(props, { slots }) {
    const { isOpen, open, id: _id } = useNestedItem(toRef(props, "value"), true);
    const id = computed(() => `v-list-group--id-${String(_id.value)}`);
    const list = useList();
    const { isBooted } = useSsrBoot();
    function onClick(e) {
      e.stopPropagation();
      open(!isOpen.value, e);
    }
    const activatorProps = computed(() => ({
      onClick,
      class: "v-list-group__header",
      id: id.value
    }));
    const toggleIcon = computed(() => isOpen.value ? props.collapseIcon : props.expandIcon);
    const activatorDefaults = computed(() => ({
      VListItem: {
        active: isOpen.value,
        activeColor: props.activeColor,
        baseColor: props.baseColor,
        color: props.color,
        prependIcon: props.prependIcon || props.subgroup && toggleIcon.value,
        appendIcon: props.appendIcon || !props.subgroup && toggleIcon.value,
        title: props.title,
        value: props.value
      }
    }));
    useRender(() => {
      var _a;
      return /* @__PURE__ */ React.createElement(
        props.tag,
        {
          class: [
            "v-list-group",
            {
              "v-list-group--prepend": list == null ? void 0 : list.hasPrepend.value,
              "v-list-group--fluid": props.fluid,
              "v-list-group--subgroup": props.subgroup,
              "v-list-group--open": isOpen.value
            },
            props.class
          ],
          style: props.style
        },
        slots.activator && /* @__PURE__ */ React.createElement(VDefaultsProvider, { defaults: activatorDefaults.value }, /* @__PURE__ */ React.createElement(VListGroupActivator, null, slots.activator({ props: activatorProps.value, isOpen: isOpen.value }))),
        /* @__PURE__ */ React.createElement(MaybeTransition, { transition: { component: VExpandTransition }, disabled: !isBooted.value }, /* @__PURE__ */ React.createElement("div", { class: "v-list-group__items", role: "group", "aria-labelledby": id.value, "v-show": isOpen.value }, (_a = slots.default) == null ? void 0 : _a.call(slots)))
      );
    });
    return {
      isOpen
    };
  }
});
const makeVListSubheaderProps = propsFactory({
  color: String,
  inset: Boolean,
  sticky: Boolean,
  title: String,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VListSubheader");
const VListSubheader = genericComponent()({
  name: "VListSubheader",
  props: makeVListSubheaderProps(),
  setup(props, { slots }) {
    const { textColorClasses, textColorStyles } = useTextColor(toRef(props, "color"));
    useRender(() => {
      var _a;
      const hasText = !!(slots.default || props.title);
      return /* @__PURE__ */ React.createElement(
        props.tag,
        {
          class: [
            "v-list-subheader",
            {
              "v-list-subheader--inset": props.inset,
              "v-list-subheader--sticky": props.sticky
            },
            textColorClasses.value,
            props.class
          ],
          style: [
            { textColorStyles },
            props.style
          ]
        },
        hasText && /* @__PURE__ */ React.createElement("div", { class: "v-list-subheader__text" }, ((_a = slots.default) == null ? void 0 : _a.call(slots)) ?? props.title)
      );
    });
    return {};
  }
});
const _VDivider = "";
const makeVDividerProps = propsFactory({
  color: String,
  inset: Boolean,
  length: [Number, String],
  opacity: [Number, String],
  thickness: [Number, String],
  vertical: Boolean,
  ...makeComponentProps(),
  ...makeThemeProps()
}, "VDivider");
const VDivider = genericComponent()({
  name: "VDivider",
  props: makeVDividerProps(),
  setup(props, { attrs, slots }) {
    const { themeClasses } = provideTheme(props);
    const { textColorClasses, textColorStyles } = useTextColor(toRef(props, "color"));
    const dividerStyles = computed(() => {
      const styles = {};
      if (props.length) {
        styles[props.vertical ? "height" : "width"] = convertToUnit(props.length);
      }
      if (props.thickness) {
        styles[props.vertical ? "borderRightWidth" : "borderTopWidth"] = convertToUnit(props.thickness);
      }
      return styles;
    });
    useRender(() => {
      const divider = /* @__PURE__ */ React.createElement(
        "hr",
        {
          class: [
            {
              "v-divider": true,
              "v-divider--inset": props.inset,
              "v-divider--vertical": props.vertical
            },
            themeClasses.value,
            textColorClasses.value,
            props.class
          ],
          style: [
            dividerStyles.value,
            textColorStyles.value,
            { "--v-border-opacity": props.opacity },
            props.style
          ],
          "aria-orientation": !attrs.role || attrs.role === "separator" ? props.vertical ? "vertical" : "horizontal" : void 0,
          role: `${attrs.role || "separator"}`
        }
      );
      if (!slots.default)
        return divider;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          class: [
            "v-divider__wrapper",
            {
              "v-divider__wrapper--vertical": props.vertical,
              "v-divider__wrapper--inset": props.inset
            }
          ]
        },
        divider,
        /* @__PURE__ */ React.createElement("div", { class: "v-divider__content" }, slots.default()),
        divider
      );
    });
    return {};
  }
});
const makeVListChildrenProps = propsFactory({
  items: Array,
  returnObject: Boolean
}, "VListChildren");
const VListChildren = genericComponent()({
  name: "VListChildren",
  props: makeVListChildrenProps(),
  setup(props, { slots }) {
    createList();
    return () => {
      var _a, _b;
      return ((_a = slots.default) == null ? void 0 : _a.call(slots)) ?? ((_b = props.items) == null ? void 0 : _b.map(({ children, props: itemProps, type, raw: item }) => {
        var _a2, _b2;
        if (type === "divider") {
          return ((_a2 = slots.divider) == null ? void 0 : _a2.call(slots, { props: itemProps })) ?? /* @__PURE__ */ React.createElement(VDivider, { ...itemProps });
        }
        if (type === "subheader") {
          return ((_b2 = slots.subheader) == null ? void 0 : _b2.call(slots, { props: itemProps })) ?? /* @__PURE__ */ React.createElement(VListSubheader, { ...itemProps });
        }
        const slotsWithItem = {
          subtitle: slots.subtitle ? (slotProps) => {
            var _a3;
            return (_a3 = slots.subtitle) == null ? void 0 : _a3.call(slots, { ...slotProps, item });
          } : void 0,
          prepend: slots.prepend ? (slotProps) => {
            var _a3;
            return (_a3 = slots.prepend) == null ? void 0 : _a3.call(slots, { ...slotProps, item });
          } : void 0,
          append: slots.append ? (slotProps) => {
            var _a3;
            return (_a3 = slots.append) == null ? void 0 : _a3.call(slots, { ...slotProps, item });
          } : void 0,
          title: slots.title ? (slotProps) => {
            var _a3;
            return (_a3 = slots.title) == null ? void 0 : _a3.call(slots, { ...slotProps, item });
          } : void 0
        };
        const listGroupProps = VListGroup.filterProps(itemProps);
        return children ? /* @__PURE__ */ React.createElement(
          VListGroup,
          {
            value: itemProps == null ? void 0 : itemProps.value,
            ...listGroupProps
          },
          {
            activator: ({ props: activatorProps }) => {
              const listItemProps = {
                ...itemProps,
                ...activatorProps,
                value: props.returnObject ? item : itemProps.value
              };
              return slots.header ? slots.header({ props: listItemProps }) : /* @__PURE__ */ React.createElement(VListItem, { ...listItemProps, "v-slots": slotsWithItem });
            },
            default: () => /* @__PURE__ */ React.createElement(
              VListChildren,
              {
                items: children,
                returnObject: props.returnObject,
                "v-slots": slots
              }
            )
          }
        ) : slots.item ? slots.item({ props: itemProps }) : /* @__PURE__ */ React.createElement(
          VListItem,
          {
            ...itemProps,
            value: props.returnObject ? item : itemProps.value,
            "v-slots": slotsWithItem
          }
        );
      }));
    };
  }
});
const makeItemsProps = propsFactory({
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: "title"
  },
  itemValue: {
    type: [String, Array, Function],
    default: "value"
  },
  itemChildren: {
    type: [Boolean, String, Array, Function],
    default: "children"
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: "props"
  },
  returnObject: Boolean,
  valueComparator: {
    type: Function,
    default: deepEqual
  }
}, "list-items");
function transformItem$1(props, item) {
  const title = getPropertyFromItem(item, props.itemTitle, item);
  const value = getPropertyFromItem(item, props.itemValue, title);
  const children = getPropertyFromItem(item, props.itemChildren);
  const itemProps = props.itemProps === true ? typeof item === "object" && item != null && !Array.isArray(item) ? "children" in item ? omit(item, ["children"]) : item : void 0 : getPropertyFromItem(item, props.itemProps);
  const _props = {
    title,
    value,
    ...itemProps
  };
  return {
    title: String(_props.title ?? ""),
    value: _props.value,
    props: _props,
    children: Array.isArray(children) ? transformItems$1(props, children) : void 0,
    raw: item
  };
}
function transformItems$1(props, items) {
  const array = [];
  for (const item of items) {
    array.push(transformItem$1(props, item));
  }
  return array;
}
function useItems(props) {
  const items = computed(() => transformItems$1(props, props.items));
  const hasNullItem = computed(() => items.value.some((item) => item.value === null));
  function transformIn(value) {
    if (!hasNullItem.value) {
      value = value.filter((v) => v !== null);
    }
    return value.map((v) => {
      if (props.returnObject && typeof v === "string") {
        return transformItem$1(props, v);
      }
      return items.value.find((item) => props.valueComparator(v, item.value)) || transformItem$1(props, v);
    });
  }
  function transformOut(value) {
    return props.returnObject ? value.map(({ raw }) => raw) : value.map(({ value: value2 }) => value2);
  }
  return { items, transformIn, transformOut };
}
function isPrimitive(value) {
  return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
}
function transformItem(props, item) {
  const type = getPropertyFromItem(item, props.itemType, "item");
  const title = isPrimitive(item) ? item : getPropertyFromItem(item, props.itemTitle);
  const value = getPropertyFromItem(item, props.itemValue, void 0);
  const children = getPropertyFromItem(item, props.itemChildren);
  const itemProps = props.itemProps === true ? omit(item, ["children"]) : getPropertyFromItem(item, props.itemProps);
  const _props = {
    title,
    value,
    ...itemProps
  };
  return {
    type,
    title: _props.title,
    value: _props.value,
    props: _props,
    children: type === "item" && children ? transformItems(props, children) : void 0,
    raw: item
  };
}
function transformItems(props, items) {
  const array = [];
  for (const item of items) {
    array.push(transformItem(props, item));
  }
  return array;
}
function useListItems(props) {
  const items = computed(() => transformItems(props, props.items));
  return { items };
}
const makeVListProps = propsFactory({
  baseColor: String,
  /* @deprecated */
  activeColor: String,
  activeClass: String,
  bgColor: String,
  disabled: Boolean,
  expandIcon: String,
  collapseIcon: String,
  lines: {
    type: [Boolean, String],
    default: "one"
  },
  slim: Boolean,
  nav: Boolean,
  "onClick:open": EventProp(),
  "onClick:select": EventProp(),
  ...makeNestedProps({
    selectStrategy: "single-leaf",
    openStrategy: "list"
  }),
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  itemType: {
    type: String,
    default: "type"
  },
  ...makeItemsProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({ variant: "text" })
}, "VList");
const VList = genericComponent()({
  name: "VList",
  props: makeVListProps(),
  emits: {
    "update:selected": (value) => true,
    "update:activated": (value) => true,
    "update:opened": (value) => true,
    "click:open": (value) => true,
    "click:activate": (value) => true,
    "click:select": (value) => true
  },
  setup(props, { slots }) {
    const { items } = useListItems(props);
    const { themeClasses } = provideTheme(props);
    const { backgroundColorClasses, backgroundColorStyles } = useBackgroundColor(toRef(props, "bgColor"));
    const { borderClasses } = useBorder(props);
    const { densityClasses } = useDensity(props);
    const { dimensionStyles } = useDimension(props);
    const { elevationClasses } = useElevation(props);
    const { roundedClasses } = useRounded(props);
    const { children, open, parents, select } = useNested(props);
    const lineClasses = computed(() => props.lines ? `v-list--${props.lines}-line` : void 0);
    const activeColor = toRef(props, "activeColor");
    const baseColor = toRef(props, "baseColor");
    const color = toRef(props, "color");
    createList();
    provideDefaults({
      VListGroup: {
        activeColor,
        baseColor,
        color,
        expandIcon: toRef(props, "expandIcon"),
        collapseIcon: toRef(props, "collapseIcon")
      },
      VListItem: {
        activeClass: toRef(props, "activeClass"),
        activeColor,
        baseColor,
        color,
        density: toRef(props, "density"),
        disabled: toRef(props, "disabled"),
        lines: toRef(props, "lines"),
        nav: toRef(props, "nav"),
        slim: toRef(props, "slim"),
        variant: toRef(props, "variant")
      }
    });
    const isFocused = shallowRef(false);
    const contentRef = ref();
    function onFocusin(e) {
      isFocused.value = true;
    }
    function onFocusout(e) {
      isFocused.value = false;
    }
    function onFocus(e) {
      var _a;
      if (!isFocused.value && !(e.relatedTarget && ((_a = contentRef.value) == null ? void 0 : _a.contains(e.relatedTarget))))
        focus();
    }
    function onKeydown(e) {
      const target = e.target;
      if (!contentRef.value || ["INPUT", "TEXTAREA"].includes(target.tagName))
        return;
      if (e.key === "ArrowDown") {
        focus("next");
      } else if (e.key === "ArrowUp") {
        focus("prev");
      } else if (e.key === "Home") {
        focus("first");
      } else if (e.key === "End") {
        focus("last");
      } else {
        return;
      }
      e.preventDefault();
    }
    function onMousedown(e) {
      isFocused.value = true;
    }
    function focus(location) {
      if (contentRef.value) {
        return focusChild(contentRef.value, location);
      }
    }
    useRender(() => {
      return /* @__PURE__ */ React.createElement(
        props.tag,
        {
          ref: contentRef,
          class: [
            "v-list",
            {
              "v-list--disabled": props.disabled,
              "v-list--nav": props.nav,
              "v-list--slim": props.slim
            },
            themeClasses.value,
            backgroundColorClasses.value,
            borderClasses.value,
            densityClasses.value,
            elevationClasses.value,
            lineClasses.value,
            roundedClasses.value,
            props.class
          ],
          style: [
            backgroundColorStyles.value,
            dimensionStyles.value,
            props.style
          ],
          tabindex: props.disabled || isFocused.value ? -1 : 0,
          role: "listbox",
          "aria-activedescendant": void 0,
          onFocusin,
          onFocusout,
          onFocus,
          onKeydown,
          onMousedown
        },
        /* @__PURE__ */ React.createElement(
          VListChildren,
          {
            items: items.value,
            returnObject: props.returnObject,
            "v-slots": slots
          }
        )
      );
    });
    return {
      open,
      select,
      focus,
      children,
      parents
    };
  }
});
export {
  VList as V,
  makeItemsProps as m,
  useItems as u
};
//# sourceMappingURL=_VList-61c79735.mjs.map
